import React, { useState, useEffect } from 'react';
import './FormularioFletes.css';
import { FletesService } from '../services/fletesService';
import { ChoferesService } from '../services/choferesService';

const FormularioFletes = ({ onCancel, fleteEditar = null }) => {
  const [choferes, setChoferes] = useState([]);
  const [formData, setFormData] = useState({
    fecha: '',
    destinoInicial: '',
    estatus: '',
    chofer: '',
    fletePagado: 'No',
    monto: '',
    destinoFinal: '',
    tipoUnidad: '',
    confirmadoPor: ''
  });

  useEffect(() => {
    const unsubscribeChoferes = ChoferesService.suscribirseChoferes(setChoferes);
    return () => {
      if (typeof unsubscribeChoferes === 'function') unsubscribeChoferes();
    };
  }, []);

  useEffect(() => {
    if (fleteEditar) {
      setFormData({
        fecha: fleteEditar.fecha || '',
        destinoInicial: fleteEditar.destinoInicial || '',
        estatus: fleteEditar.estatus || '',
        chofer: fleteEditar.chofer || '',
        fletePagado: fleteEditar.fletePagado || 'No',
        monto: fleteEditar.monto || '',
        destinoFinal: fleteEditar.destinoFinal || '',
        tipoUnidad: fleteEditar.tipoUnidad || '',
        confirmadoPor: fleteEditar.confirmadoPor || ''
      });
    } else {
      setFormData({
        fecha: '',
        destinoInicial: '',
        estatus: '',
        chofer: '',
        fletePagado: 'No',
        monto: '',
        destinoFinal: '',
        tipoUnidad: '',
        confirmadoPor: ''
      });
    }
  }, [fleteEditar]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (fleteEditar) {
        await FletesService.actualizarFlete(fleteEditar.id, formData);
        alert('Flete actualizado correctamente');
      } else {
        await FletesService.crearFlete(formData);
        alert('Flete registrado correctamente');
      }
      
      if (onCancel) {
        onCancel();
      }
    } catch (error) {
      console.error('Error al guardar flete:', error);
      alert('Error al guardar el flete');
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content flete-modal">
        <div className="modal-header flete-header">
          <h2>{fleteEditar ? 'Editar Flete' : 'Registrar Flete'}</h2>
          <button className="close-button" onClick={handleCancel}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="formulario-flete">
          <div className="form-row-flete">
            {/* Columna Izquierda */}
            <div className="form-column">
              <div className="form-group-flete">
                <label htmlFor="fecha">FECHA:</label>
                <div className="input-with-icon">
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleInputChange}
                    required
                    className="input-red-border"
                  />
                </div>
              </div>

              <div className="form-group-flete">
                <label htmlFor="destinoInicial">DESTINO INICIAL:</label>
                <input
                  type="text"
                  id="destinoInicial"
                  name="destinoInicial"
                  value={formData.destinoInicial}
                  onChange={handleInputChange}
                  required
                  className="input-red-border"
                />
              </div>

              <div className="form-group-flete">
                <label htmlFor="estatus">ESTATUS DEL FLETE:</label>
                <select
                  id="estatus"
                  name="estatus"
                  value={formData.estatus}
                  onChange={handleInputChange}
                  required
                  className="input-red-border"
                >
                  <option value="">Seleccionar...</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="En tránsito">En tránsito</option>
                  <option value="Entregado">Entregado</option>
                  <option value="Cancelado">Cancelado</option>
                </select>
              </div>

              <div className="form-group-flete">
                <label htmlFor="chofer">CHOFER:</label>
                <select
                  id="chofer"
                  name="chofer"
                  value={formData.chofer}
                  onChange={handleInputChange}
                  required
                  className="input-red-border"
                >
                  <option value="">Seleccionar...</option>
                  {choferes.map(chofer => (
                    <option key={chofer.id} value={`${chofer.nombre} ${chofer.apellido || ''}`.trim()}>
                      {chofer.nombre} {chofer.apellido || ''}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group-flete">
                <label htmlFor="fletePagado">¿FLETE PAGADO?:</label>
                <select
                  id="fletePagado"
                  name="fletePagado"
                  value={formData.fletePagado}
                  onChange={handleInputChange}
                  required
                  className="input-red-border"
                >
                  <option value="No">No</option>
                  <option value="Sí">Sí</option>
                </select>
              </div>
            </div>

            {/* Columna Derecha */}
            <div className="form-column">
              <div className="form-group-flete">
                <label htmlFor="monto">MONTO ($):</label>
                <input
                  type="number"
                  id="monto"
                  name="monto"
                  value={formData.monto}
                  onChange={handleInputChange}
                  required
                  step="0.01"
                  min="0"
                  className="input-red-border"
                />
              </div>

              <div className="form-group-flete">
                <label htmlFor="destinoFinal">DESTINO FINAL:</label>
                <input
                  type="text"
                  id="destinoFinal"
                  name="destinoFinal"
                  value={formData.destinoFinal}
                  onChange={handleInputChange}
                  required
                  className="input-red-border"
                />
              </div>

              <div className="form-group-flete">
                <label htmlFor="tipoUnidad">TIPO DE UNIDAD:</label>
                <input
                  type="text"
                  id="tipoUnidad"
                  name="tipoUnidad"
                  value={formData.tipoUnidad}
                  onChange={handleInputChange}
                  placeholder="ej. Camión, Camioneta, etc."
                  className="input-green-border"
                />
              </div>

              <div className="form-group-flete">
                <label htmlFor="confirmadoPor">CONFIRMADO POR:</label>
                <input
                  type="text"
                  id="confirmadoPor"
                  name="confirmadoPor"
                  value={formData.confirmadoPor}
                  onChange={handleInputChange}
                  className="input-green-border"
                />
              </div>
            </div>
          </div>

          {/* Botones de acción */}
          <div className="form-actions-flete">
            <button type="button" className="btn-cancel-flete" onClick={handleCancel}>
              Cancelar
            </button>
            <button type="submit" className="btn-submit-flete">
              {fleteEditar ? 'Guardar Cambios' : 'Registrar Flete'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormularioFletes;












